// Copyright (c) 2017 Deere & Company

import {translate} from '../../shared/services/translation-service';

export const getAgGridLocaleText = () => ({
    contains: translate('CONTAINS'),
    endsWith: translate('ENDS_WITH'),
    equals: translate('EQUALS'),
    filterOoo: translate('FILTER_WITH_ELLIPSIS'),
    greaterThan: translate('GREATER_THAN'),
    greaterThanOrEqual: translate('GREATER_THAN_OR_EQUALS'),
    inRange: translate('IN_RANGE'),
    lessThan: translate('LESS_THAN'),
    lessThanOrEqual: translate('LESS_THAN_OR_EQUALS'),
    noRowsToShow: translate('NO_ROWS_TO_SHOW'),
    notContains: translate('DOES_NOT_CONTAIN'),
    notEqual: translate('NOT_EQUAL'),
    startsWith: translate('STARTS_WITH')
});



// WEBPACK FOOTER //
// ./src/shared/utils/ag-grid-locale-text.js